import { render, staticRenderFns } from "./AddMfa.vue?vue&type=template&id=f0a692ae&scoped=true"
import script from "./AddMfa.vue?vue&type=script&lang=ts"
export * from "./AddMfa.vue?vue&type=script&lang=ts"
import style0 from "./AddMfa.vue?vue&type=style&index=0&id=f0a692ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a692ae",
  null
  
)

export default component.exports